// Predicate helper for VariationActiveFilterSummary + VariationFilterChipBar
// — returns true when any chip filter or search term is non-default. Lifted
// to its own module so the component file exports only the React component
// (react-refresh/only-export-components).

import type { VariationFilters } from "./applyVariationFilters";

export function hasAnyActiveVariationFilter(
  filters: VariationFilters,
  search: string,
): boolean {
  if (filters.status.length > 0) return true;
  if (filters.varies.length > 0) return true;
  if (filters.type.length > 0) return true;
  if (filters.dateRange !== "all-time") return true;
  if (filters.includeArchived) return true;
  if (search.trim().length > 0) return true;
  return false;
}
